
import { FirearmStorageLocationEntityDecorator } from './firearm-storage-location.decorator';
import { FirearmStorageLocation } from './firearm-storage-location.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class FirearmStorageLocationTypeInfoBase implements CrudTypeInfo<FirearmStorageLocation, number> {
  name = 'Firearm Storage Location';
  entityDecorator = new FirearmStorageLocationEntityDecorator();
  
  createAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION'];
  editAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION'];
  deleteAuthorities = ['WRITE_FIREARM_STORAGE_LOCATION'];
  viewAuthorities = ['READ_FIREARM_STORAGE_LOCATION'];
  
  searchRouteBase = ['/firearmstoragelocation/search'];
  createRouteBase = ['/firearmstoragelocation/create'];
  editRouteBase = ['/firearmstoragelocation/edit'];
  viewRouteBase = ['/firearmstoragelocation/view'];
  
  description(item: FirearmStorageLocation): string {
    return '' +  item.firearmStorageLocationId +  ' - ' +  item.description;
  }
}



